import React, { useEffect } from 'react';
import { GoArrowUpRight } from "react-icons/go";

const AnimatedCard = ({ title,heading, content }) => {
  useEffect(() => {
    const styleTag = document.createElement('style');
    styleTag.innerHTML = `
      .animated-card {
        --offset: 2px;
        background: #0C0A00;
        border-radius: 6px;
        position: relative;
        height: 300px;
        margin: 10px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: start;
        padding: 20px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
        transition: transform 0.3s ease;
      }

      .animated-card::before {
        content: '';
        background: conic-gradient(transparent 270deg, #FFD52B, transparent);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(1.5);
        width: 200%;
        height: 200%;
        border-radius: 50%;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.3s ease;
      }

      .animated-card::after {
        content: '';
        background: inherit;
        border-radius: inherit;
        position: absolute;
        inset: var(--offset);
        height: calc(100% - 2 * var(--offset));
        width: calc(100% - 2 * var(--offset));
        z-index: 1;
      }

      .animated-card:hover::before {
        opacity: 1;
        animation: rotate 2s linear infinite;
      }
        .animated-card:hover .card-icon {
        color: #FFD52B;
      }

      .card-content {
        position: relative;
        z-index: 2;
        text-align: left;
        color: #FFD52B;
        
      }

      .card-title {
        font-size: 1.5rem;
        font-weight: bold;
        margin-bottom: 4px;

      }

      .card-text {
        font-size: 0.9rem;
        margin-bottom: 20px;
        color:white;
      }

      @keyframes rotate {
        from {
          transform: translate(-50%, -50%) scale(1.5) rotate(0turn);
        }
        to {
          transform: translate(-50%, -50%) scale(1.5) rotate(1turn);
        }
      }
    `;
    document.head.appendChild(styleTag);

    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);

  return (
    <div className="animated-card">
      <div className="card-content">
        <div className="card-title" >{title}</div>
        <hr style={{color:"grey"}}></hr>
        <div className="card-text" style={{fontWeight:'bold'}}>{heading}</div>
        <p style={{color:'white',fontSize:'0.8rem'}} >{content}</p>
      </div>
      <div className='card-icon' style={{position:"absolute" , bottom:"-20px",right:'20px' , zIndex:'100'}}>
        <GoArrowUpRight size={70}  /></div>
      
    </div>
  );
};

export default AnimatedCard;
